import clsx from 'clsx';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/sharp-solid-svg-icons';
import { Spinner } from 'flowbite-react';

type ButtonProps = {
    label?: string;
    buttonType?: string;
    loading?: boolean;
    isArrow?: boolean;
} & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

const Button = ({ label, className, loading, isArrow, ...props }: ButtonProps) => {
    return (
        <button
            className={clsx(
                `py-4 px-6 ${ isArrow ? 'bg-primary-700' : 'bg-white' }  text-white flex items-center gap-3 text-base rounded font-medium disabled:opacity-30`,
                className,
            )}
            {...props}
        >
            {loading && <Spinner size="md" />}
            {!loading && (
                <>
                    {label}
                    {isArrow && <FontAwesomeIcon className="w-4 h-4" icon={faArrowRight} />}
                </>
            )}
        </button>
    );
};

export default Button;
